function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * inpired by @see http://leanrada.com/htmz/
 * 
  // https://leanrada.com/htmz/extensions/ (multitarget)
 * **/
import vent from 'elements/vent';
export var fajax = new (/*#__PURE__*/function () {
  function FakeAjax() {
    _classCallCheck(this, FakeAjax);
    this.init();
  }
  return _createClass(FakeAjax, [{
    key: "init",
    value: function init() {
      window.fajax = this.onFajax.bind(this);
      window.fetchFajax = function (url, formData) {
        var form = document.querySelector('#form-fajax');
        form.setAttribute('action', url);
        form.formData = formData;
        form.requestSubmit();
      };
      var container = document.createElement('div');
      container.innerHTML = '<span class="loading-spinner"></span><iframe hidden name="fajax" onload="window.fajax(this)"></iframe><form hidden method="post" target="fajax" id="form-fajax"> </form>';
      document.body.appendChild(container);
      document.addEventDelegate('click', this.loading.bind(this), 'a[target="fajax"]');
      document.addEventDelegate('submit', this.loading.bind(this), 'form[target="fajax"]');
      // fajax
    }
  }, {
    key: "onFajax",
    value: function onFajax(frame) {
      var _this = this;
      // if (frame.contentWindow.location.href === 'about:blank') return;

      frame.contentWindow.addEventListener('unload', function () {
        // Wait for destination location for the hash
        setTimeout(function () {
          vent.publish('APP:UNLOAD');
          _this.loading();
        });
      });
      // if (!frame.contentWindow.location.hash) return;

      setTimeout(function () {
        vent.publish('APP:LOAD');
        if (frame.contentWindow.location.hash) {
          var receiver = document.querySelector(frame.contentWindow.location.hash);
          if (receiver) {
            var content = frame.contentDocument.body.querySelector(frame.contentWindow.location.hash);
            content = content ? content.innerHTML : frame.contentDocument.body.innerHTML;
            if (content) {
              setTimeout(function () {
                receiver.innerHTML = content;
                _this.loaded();
              });
            }
          }
        } else {
          var templates = frame.contentWindow.document.body.querySelectorAll('template');
          templates.forEach(function (tpl) {
            if (tpl.getAttribute('action') == 'location') {
              window.location.href = tpl.id;
              return;
            }
            if (tpl.getAttribute('action') == 'reload') {
              window.location.reload();
              return;
            }
            var receiver = document.getElementById(tpl.id);
            if (receiver) {
              if (tpl.getAttribute('action') == 'append') {
                receiver.innerHTML += tpl.innerHTML;
              } else if (tpl.getAttribute('action') == 'remove') {
                receiver.remove();
              } else if (tpl.getAttribute('action') == 'update') {
                receiver.innerHTML = tpl.innerHTML;
              } else if (tpl.getAttribute('action') == 'scroll') {
                setTimeout(function (_) {
                  document.getElementById(tpl.id).scrollIntoView({
                    behavior: 'smooth',
                    inline: 'nearest'
                  });
                }, 100);
              } else {
                // replace ...
                receiver.outerHTML = tpl.innerHTML;
              }
            }
          });
          _this.loaded();
        }

        // const receiver = document.querySelector(frame.contentWindow.location.hash);
        // document.body.setAttribute('aria-busy', 'false');
        // if (receiver) {
        //   let content = frame.contentDocument.body.querySelector(frame.contentWindow.location.hash);
        //   content = content ? content.innerHTML : frame.contentDocument.body.innerHTML;
        //   if (content) {
        //     setTimeout(() => {
        //       receiver.innerHTML = content;
        //       // document.dispatchEventDelegate('APP:RELOAD');
        //     });
        //   }
        // }
      });
    }
  }, {
    key: "loaded",
    value: function loaded() {
      document.body.setAttribute('aria-busy', 'false');
      vent.publish('APP:READY');
      // document.dispatchEventDelegate('APP:RELOAD');
    }
  }, {
    key: "loading",
    value: function loading() {
      document.body.setAttribute('aria-busy', 'true');
    }
  }]);
}())();